import React, { memo, useMemo, useState } from "react";
import { IconButton, Tooltip, Stack, Icon } from "investira.react.components";
import { validators } from "investira.sdk";
import { useSelector } from "react-redux";
import { BulkContextActions, DataTable } from "../../../components/organisms";
import EnquadramentoRegrasEditDialog from "./EnquadramentoRegrasEditDialog";

const EnquadramentoRegras = memo((props) => {
  const {
    enquadramentos,
    state,
    columns,
    renderDetailPanel,
    onBulkDeleteClick,
    ...restProps
  } = props;

  const [selected, setSelected] = useState(null);

  const storedRegras = useSelector(
    (store) => store.reports.enquadramento.regras.data
  );

  const xColumns = useMemo(() => {
    return [
      {
        id: "descricao",
        accessorKey: "descricao",
        header: "Descrição",
        enableColumnActions: false,
        enableSorting: false,
        grow: true,
        muiTableHeadCellProps: {
          sx: {
            width: "100% !important",
          },
        },
        Cell: ({ cell }) => {
          if (validators.isNull(cell.getValue())) {
            return;
          }
          return cell.getValue();
        },
      },
      {
        id: "minimo",
        accessorKey: "minimo",
        header: "Mínimo",
        enableColumnActions: false,
        enableSorting: false,
        muiTableHeadCellProps: {
          align: "right",
        },
        muiTableBodyCellProps: {
          align: "right",
        },
        Cell: ({ cell }) => {
          if (validators.isNull(cell.getValue())) {
            return;
          }
          return `${cell.getValue()}%`;
        },
      },
      {
        id: "maximo",
        accessorKey: "maximo",
        header: "Máximo",
        enableColumnActions: false,
        enableSorting: false,
        muiTableHeadCellProps: {
          align: "right",
        },
        muiTableBodyCellProps: {
          align: "right",
        },
        Cell: ({ cell }) => {
          if (validators.isNull(cell.getValue())) {
            return;
          }
          return `${cell.getValue()}%`;
        },
      },
      {
        id: "alvo",
        accessorKey: "alvo",
        header: "Alvo",
        enableColumnActions: false,
        enableSorting: false,
        muiTableHeadCellProps: {
          align: "right",
        },
        muiTableBodyCellProps: {
          align: "right",
        },
        Cell: ({ cell }) => {
          if (validators.isNull(cell.getValue())) {
            return;
          }
          return `${cell.getValue()}%`;
        },
      },
      {
        id: "regra_id",
        accessorKey: "enquadramento_regra_id",
        header: "Regra ID",
        enableColumnActions: false,
        enableSorting: false,
        size: 20,
      },
      // {
      //   id: "resolucao",
      //   accessorKey: "enquadramento_regra_id",
      //   header: "Resolução",
      //   enableColumnActions: false,
      //   enableSorting: false,
      //   Cell: ({ cell }) => {
      //     if (validators.isNull(cell.getValue())) {
      //       return;
      //     }
      //     return storedRegras[cell.getValue()].enquadramento_resolucao.id;
      //   },
      // },
      // {
      //   id: "limite",
      //   accessorKey: "enquadramento_regra_id",
      //   header: "Limite",
      //   enableColumnActions: false,
      //   enableSorting: false,
      //   grow: true,
      //   Cell: ({ cell }) => {
      //     if (validators.isNull(cell.getValue())) {
      //       return;
      //     }
      //     return `${
      //       storedRegras[cell.getValue()].enquadramento_secao.descricao
      //     }`;
      //   },
      // },
    ];
  }, []);

  const xProps = {
    columns: xColumns,
    data: props.regras,
    readData: props.readRegras,
    isLoading: props.isLoading,
    initialState: {
      pagination: props.pagination,
      columnVisibility: { carteira: false },
      columnSizing: {
        // Define larguras fixas para as colunas de seleção e ações
        "mrt-row-select": 50, // Largura fixa para a coluna de seleção
        "mrt-row-actions": 80, // Largura fixa para a coluna de ações
      },
    },
    defaultColumn: {
      size: 1, // Largura padrão de 120px para todas as colunas
      minSize: 1, // Largura mínima padrão de 80px
      maxSize: 300, // Largura máxima padrão de 300px
    },
    manualFiltering: true,
    manualSorting: true,
    manualPagination: true,
    getRowId: (row) => row.log_id,
    state: {
      isLoading: props.isLoading,
      pagination: props.pagination,
      showProgressBars: props.isRefetching,
      columnFilters: props.columnFilters,
      sorting: props.sorting,
      rowSelection: props.rowSelection,
    },
    rowCount: props.rowCount,
    onColumnFiltersChange: props.setColumnFilters,
    onSortingChange: props.setSorting,
    onPaginationChange: props.setPagination,
    onRowSelectionChange: props.setRowSelection,
    onGlobalFilterChange: props.setGlobalFilter,
    //onBulkDeleteClick: props.bulkDeleteLogs,
    enableRowSelection: true,
    renderTopToolbarCustomActions: ({ table }) => {
      const selectedRows = table.getSelectedRowModel().rows;
      const isSomeRowSelected = selectedRows.length > 0;

      return (
        <BulkContextActions
          onDeleteClick={() => {
            console.log(selectedRows);
            props.bulkDeleteRegras(selectedRows);
          }}
          disabled={props.isLoading || props.isRefetching || !isSomeRowSelected}
        />
      );
    },
    muiTableContainerProps: {
      sx: {
        maxWidth: "100%", // Garante que a tabela ocupe 100% do espaço disponível
      },
    },
    displayColumnDefOptions: {
      "mrt-row-actions": {
        size: 80, // largura em pixels para a coluna de ações
      },
      "mrt-row-select": {
        size: 50, // largura em pixels para a coluna de seleção
      },
    },
    renderRowActions: ({ row }) => {
      return (
        <Stack direction="row" spacing={1}>
          <Tooltip title="Editar">
            <span>
              <IconButton
                color="primary"
                onClick={() => setSelected(row.original)}
              >
                <Icon iconName="edit" size={18} />
              </IconButton>
            </span>
          </Tooltip>
        </Stack>
      );
    },
    ...restProps,
  };

  return (
    <>
      <DataTable {...xProps} />
      {selected && (
        <EnquadramentoRegrasEditDialog
          open={Boolean(selected)}
          data={selected}
          onClose={() => setSelected(null)}
          readData={props.readRegras}
        />
      )}
    </>
  );
});

EnquadramentoRegras.displayName = "EnquadramentoRegras";

export default EnquadramentoRegras;
